
import { Vue, Component, Prop } from 'vue-property-decorator'

import CustomWrapper from '@/components/CustomWrapper.vue'

const config = {
  name: 'c-audio-card-player',
  components: { CustomWrapper }
}

@Component(config)
export default class CAudioCardPlayer extends Vue {

  @Prop({ type: String, default: 'div' }) tag!: string
  @Prop({ type: String, required: true }) src!: string
  @Prop({ type: String, required: true }) contentType!: string

}
